import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './UserInfo.css';
import { useNavigate } from 'react-router-dom';

const getContactUpdateRoute = (role: string) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  switch (role) {
    case 'Acheteur signataire admin':
      return `${apiUrl}/responsables-achat/me`;
    case 'Acheteur signataire':
      return `${apiUrl}/validateurs-achat/me`;
    case 'Acheteur':
      return `${apiUrl}/acheteurs/me`;
    case 'Prestataire signataire admin':
      return `${apiUrl}/gestionnaires/me`;
    case 'Prestataire signataire':
      return `${apiUrl}/signataires/me`;
    case 'Prestataire':
      return `${apiUrl}/interlocuteurs/me`;
    default:
      return '';
  }
};

const UserInfo: React.FC = () => {
  const { user } = useAuth();
  const [userInfo, setUserInfo] = useState<{ nom?: string; prenom?: string; organisation?: string; role?: string }>({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (!user?.role) return;
      const route = getContactUpdateRoute(user.role);
      if (!route) return;

      const token = localStorage.getItem('token');

      try {
        const response = await fetch(route, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });

        if (response.status === 401 || response.status === 403) {
          navigate('/login', { replace: true });
        }

        if (response.ok) {
          const data = await response.json();
          setUserInfo({
            nom: data.data.nom,
            prenom: data.data.prenom,
            organisation: data.data.organisme?.nom ?? data.data.entite?.nom,
            role: user.role
          });
        }
      } catch (e) {
        setUserInfo({});
      }
    };

    fetchUserInfo();
  }, [user?.role, navigate]);

  return (
    <div className="user-info-display">
      <div className="user-info-name">
        {userInfo.nom || ''} {userInfo.prenom || ''}, {userInfo.organisation || 'Organisation'}, <span className='user-info-role'>{userInfo.role || 'Role'}</span>
      </div>
    </div>
  );
};

export default UserInfo;